import { render, staticRenderFns } from "./DetailsCheckboxInput.vue?vue&type=template&id=17db9688"
import script from "./DetailsCheckboxInput.vue?vue&type=script&lang=ts"
export * from "./DetailsCheckboxInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports